"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Footer = void 0;

require("../style/index.css");

var _preact = _interopRequireWildcard(require("preact"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _render = require("../utils/render.utils");

var _WithFetch = require("./hocs/WithFetch");

var _Doormat = _interopRequireDefault(require("./footer/Doormat"));

var _fetch = require("../utils/fetch.utils");

var _function = require("../utils/function.utils");

var _WithToggle = require("./hocs/WithToggle");

var _Footer$propTypes;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Footer = /*#__PURE__*/function (_Component) {
  _inherits(Footer, _Component);

  var _super = _createSuper(Footer);

  function Footer() {
    var _this;

    _classCallCheck(this, Footer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_renderLink", function (id, label, link, onClick, eventName, renderFunction) {
      if (onClick) {
        var _onClick = function _onClick() {
          return (0, _function.callFunction)(onClick, eventName, {});
        };

        return (0, _preact.h)("a", {
          id: id,
          onClick: _onClick,
          className: "mtn-o-footer__link",
          href: "javascript:void(0);"
        }, label);
      }

      if (link) {
        return (0, _render.renderLink)(link, label, 'mtn-o-footer__link', renderFunction, id);
      }

      return null;
    });

    return _this;
  }

  _createClass(Footer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var node = document.getElementById('mtn-footer');
      node && node.addEventListener('click', _function.globalClickHandler);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var node = document.getElementById('mtn-footer');
      node && node.removeEventListener('click', _function.globalClickHandler);
      node && node.addEventListener('click', _function.globalClickHandler);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var node = document.getElementById('mtn-footer');
      node && node.removeEventListener('click', _function.globalClickHandler);
    }
  }, {
    key: "render",
    value: function render() {
      var props = (0, _render.camelCaseProps)(_objectSpread(_objectSpread({}, this.props), (0, _fetch.flattenConfig)((0, _render.jsonParse)(this.props.config))));

      var className = props.className,
          doormatBottomLinks = props.doormatBottomLinks,
          doormatBottomTitle = props.doormatBottomTitle,
          doormatCenter = props.doormatCenter,
          doormatClassName = props.doormatClassName,
          doormatLeft = props.doormatLeft,
          doormatLinksRenderFunction = props.doormatLinksRenderFunction,
          doormatRight = props.doormatRight,
          doormatStyle = props.doormatStyle,
          doormatTopLabel = props.doormatTopLabel,
          doormatTopLink = props.doormatTopLink,
          doormatTopTarget = props.doormatTopTarget,
          doormatTopTitle = props.doormatTopTitle,
          doormatTopTitleHidden = props.doormatTopTitleHidden,
          firstLink = props.firstLink,
          firstLinkFunction = props.firstLinkFunction,
          firstLinkLabel = props.firstLinkLabel,
          firstLinkRenderFunction = props.firstLinkRenderFunction,
          footerClassName = props.footerClassName,
          footerStyle = props.footerStyle,
          fourthLink = props.fourthLink,
          fourthLinkFunction = props.fourthLinkFunction,
          fourthLinkLabel = props.fourthLinkLabel,
          fourthLinkRenderFunction = props.fourthLinkRenderFunction,
          linksRenderFunction = props.linksRenderFunction,
          secondLink = props.secondLink,
          secondLinkFunction = props.secondLinkFunction,
          secondLinkLabel = props.secondLinkLabel,
          secondLinkRenderFunction = props.secondLinkRenderFunction,
          style = props.style,
          text = props.text,
          thirdLink = props.thirdLink,
          thirdLinkFunction = props.thirdLinkFunction,
          thirdLinkLabel = props.thirdLinkLabel,
          thirdLinkRenderFunction = props.thirdLinkRenderFunction,
          rest = _objectWithoutProperties(props, ["className", "doormatBottomLinks", "doormatBottomTitle", "doormatCenter", "doormatClassName", "doormatLeft", "doormatLinksRenderFunction", "doormatRight", "doormatStyle", "doormatTopLabel", "doormatTopLink", "doormatTopTarget", "doormatTopTitle", "doormatTopTitleHidden", "firstLink", "firstLinkFunction", "firstLinkLabel", "firstLinkRenderFunction", "footerClassName", "footerStyle", "fourthLink", "fourthLinkFunction", "fourthLinkLabel", "fourthLinkRenderFunction", "linksRenderFunction", "secondLink", "secondLinkFunction", "secondLinkLabel", "secondLinkRenderFunction", "style", "text", "thirdLink", "thirdLinkFunction", "thirdLinkLabel", "thirdLinkRenderFunction"]);

      delete rest.configUrl;
      delete rest.config;
      delete rest.loading;
      delete rest.mtnid;
      delete rest.forcelanguage;
      delete rest.innerChangeLanguage;
      return (0, _preact.h)("footer", _extends({}, rest, {
        className: "".concat(className ? className : ''),
        style: style,
        id: "mtn-footer"
      }), (0, _preact.h)(_Doormat["default"], {
        bottomTitle: doormatBottomTitle,
        bottomLinks: doormatBottomLinks,
        topLabel: doormatTopLabel,
        topLink: doormatTopLink,
        topTarget: doormatTopTarget,
        topTitle: doormatTopTitle,
        topTitleHidden: doormatTopTitleHidden,
        className: doormatClassName,
        style: doormatStyle,
        linksRenderFunction: doormatLinksRenderFunction,
        center: doormatCenter,
        left: doormatLeft,
        right: doormatRight
      }), (0, _preact.h)("div", {
        id: "mtn-footer-bottom",
        style: footerStyle,
        className: "mtn-o-footer o-footer ".concat(footerClassName ? footerClassName : '')
      }, text, this._renderLink('mtn-footer-bottom-link-1', firstLinkLabel, firstLink, firstLinkFunction, 'onFooterClickFirst', firstLinkRenderFunction || linksRenderFunction), this._renderLink('mtn-footer-bottom-link-2', secondLinkLabel, secondLink, secondLinkFunction, 'onFooterClickSecond', secondLinkRenderFunction || linksRenderFunction), this._renderLink('mtn-footer-bottom-link-3', thirdLinkLabel, thirdLink, thirdLinkFunction, 'onFooterClickThird', thirdLinkRenderFunction || linksRenderFunction), this._renderLink('mtn-footer-bottom-link-4', fourthLinkLabel, fourthLink, fourthLinkFunction, 'onFooterClickFourth', fourthLinkRenderFunction || linksRenderFunction)));
    }
  }]);

  return Footer;
}(_preact.Component);

exports.Footer = Footer;
Footer.propTypes = (_Footer$propTypes = {
  /** Add extra className to top element. */
  className: _propTypes["default"].string,

  /** Add extra className to footer element. */
  footerClassName: _propTypes["default"].string,

  /** Add extra className to doormat element. */
  doormatClassName: _propTypes["default"].string,

  /** Style object, set on top footer element. */
  style: _propTypes["default"].object,

  /** Style object, set on footer element. */
  footerStyle: _propTypes["default"].object,

  /** Style object, set on doormat element. */
  doormatStyle: _propTypes["default"].object,

  /** Main text in the center of the footer. */
  text: _propTypes["default"].string,

  /** Label for the first link, only displayed if "firstLink" is set. */
  firstLinkLabel: _propTypes["default"].string,

  /** Label for the second link, only displayed if "secondLink" is set. */
  secondLinkLabel: _propTypes["default"].string,

  /** Label for the second link, only displayed if "thirdLink" is set. */
  thirdLinkLabel: _propTypes["default"].string,

  /** URL for the first link. */
  firstLink: _propTypes["default"].string,

  /** Function to call when clicking on the first link (overrides the link). */
  firstLinkFunction: _propTypes["default"].func,

  /** URL for the second link. */
  secondLink: _propTypes["default"].string,

  /** Function to call when clicking on the second link (overrides the link). */
  secondLinkFunction: _propTypes["default"].func
}, _defineProperty(_Footer$propTypes, "secondLink", _propTypes["default"].string), _defineProperty(_Footer$propTypes, "thirdLinkFunction", _propTypes["default"].func), _defineProperty(_Footer$propTypes, "linksRenderFunction", _propTypes["default"].func), _defineProperty(_Footer$propTypes, "firstLinkRenderFunction", _propTypes["default"].func), _defineProperty(_Footer$propTypes, "secondLinkRenderFunction", _propTypes["default"].func), _defineProperty(_Footer$propTypes, "thirdLinkRenderFunction", _propTypes["default"].func), _defineProperty(_Footer$propTypes, "configUrl", _propTypes["default"].string), _defineProperty(_Footer$propTypes, "doormatLeft", _propTypes["default"].array), _defineProperty(_Footer$propTypes, "doormatCenter", _propTypes["default"].array), _defineProperty(_Footer$propTypes, "doormatRight", _propTypes["default"].array), _defineProperty(_Footer$propTypes, "doormatTopLink", _propTypes["default"].string), _defineProperty(_Footer$propTypes, "doormatTopTarget", _propTypes["default"].string), _defineProperty(_Footer$propTypes, "doormatTopLabel", _propTypes["default"].string), _defineProperty(_Footer$propTypes, "doormatTopTitle", _propTypes["default"].string), _defineProperty(_Footer$propTypes, "doormatTopTitleHidden", _propTypes["default"].string), _defineProperty(_Footer$propTypes, "doormatBottomLinks", _propTypes["default"].array), _defineProperty(_Footer$propTypes, "doormatBottomTitle", _propTypes["default"].string), _defineProperty(_Footer$propTypes, "doormatLinksRenderFunction", _propTypes["default"].func), _defineProperty(_Footer$propTypes, "config", _propTypes["default"].object), _defineProperty(_Footer$propTypes, "webcomponent", _propTypes["default"].bool), _Footer$propTypes);
Footer.defaultProps = {
  className: '',
  configUrl: '',
  doormatBottomLinks: [],
  doormatBottomTitle: '',
  doormatCenter: [],
  doormatClassName: '',
  doormatLeft: [],
  doormatLinksRenderFunction: null,
  doormatRight: [],
  doormatStyle: {},
  doormatTopLabel: 'Meld het ons',
  doormatTopLink: '',
  doormatTopTarget: '_blank',
  doormatTopTitle: 'Iets onduidelijk op deze pagina?',
  doormatTopTitleHidden: 'Iets onduidelijk op deze pagina?',
  firstLink: '',
  firstLinkFunction: null,
  firstLinkLabel: 'Privacy',
  firstLinkRenderFunction: null,
  footerClassName: '',
  footerStyle: {},
  fourthLink: '',
  fourthLinkFunction: null,
  fourthLinkLabel: '',
  fourthLinkRenderFunction: null,
  linksRenderFunction: null,
  secondLink: '',
  secondLinkFunction: null,
  secondLinkLabel: 'Toegankelijkheid',
  secondLinkRenderFunction: null,
  style: {},
  text: '© stad Antwerpen',
  thirdLink: '',
  thirdLinkFunction: null,
  thirdLinkLabel: 'Cookies',
  thirdLinkRenderFunction: null,
  webcomponent: false
};

var _default = (0, _WithToggle.withToggle)((0, _WithFetch.withFetch)(Footer, 'footer'));

exports["default"] = _default;